module.exports = __webpack_public_path__ + "img/shuiyuan.d341ccaf.png";